import axios from "axios";
import { readLegacyAuthToken } from "./security/legacyAuth";

const isLocalFrontend = typeof window !== "undefined"
  && ["localhost", "127.0.0.1"].includes(window.location.hostname);
// Use the same origin as login so session and CSRF cookies stay together.
const apiBase = isLocalFrontend
  ? process.env.REACT_APP_API_BASE_URL_LOCAL || ""
  : process.env.REACT_APP_API_BASE_URL || "";

const api = axios.create({
  baseURL: apiBase,
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
});

api.interceptors.request.use((config) => {
  const token = readLegacyAuthToken();
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  if (String(config.url || "").includes("/employment/")) {
    config.headers["X-Eternua-Trace-ID"] = window.crypto?.randomUUID?.()
      || `00000000-0000-4000-8000-${Date.now().toString().padStart(12, "0").slice(-12)}`;
  }
  return config;
});

export default api;
